import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import moment from 'moment';
import { firstValueFrom } from 'rxjs';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { CustomListDropdown } from 'src/app/interfaces/custom-list/custom-list-dropdown.interface';
import { CustomTableReport } from 'src/app/interfaces/custom-table-report/custom-table-report.interface';
import { InvoicingReportFilterModel } from 'src/app/models/invoicing/invoicing-report-filter.model';
import { CostCenterService } from 'src/app/services/archive/cost-center.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { InvoicingReportService } from 'src/app/services/invoicing/invoicing-report.service';
import { BranchService } from 'src/app/services/management/branch.service';
import { ConceptInvoicingService } from 'src/app/services/invoicing/concept-invoicing.service';
import { EnterpriseService } from 'src/app/services/management/enterprise.service';
import { RentalPeriodService } from 'src/app/services/rental/rental-period.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { CustomValidators } from 'src/app/validators/custom-validators';

@Component({
  selector: 'app-income-report',
  templateUrl: './income-report.component.html',
  styleUrls: ['./income-report.component.scss'],
  standalone: false
})
export class IncomeReportComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('filtersContainer') filtersContainer!: ElementRef;

  changeFilters: boolean = false;
  dataReport: CustomTableReport;
  filterObserver?: ResizeObserver;
  filtersHeight: number = 0;
  filteredEnterprise: any[] = [];
  formInvoicingReportFilter: FormGroup = new FormGroup({});
  listBranch: any[] = [];
  listConceptInvoicing: any[] = [];
  listCostCenter: any[] = [];
  listEnterprise: any[] = [];
  listReportType: CustomListDropdown[] = [{ label: 'Todos', value: 0 }, { label: 'Tercero', value: 1 },
  { label: 'Administración', value: 2 }, { label: 'Propio', value: 3 }
  ];
  nameWindow: string = 'Informe de Ingresos (Corte)';
  projectName = ProjectName.projectName;

  constructor(private branchService: BranchService,
    private conceptInvoicingService: ConceptInvoicingService,
    private costCenterService: CostCenterService,
    private enterpriseService: EnterpriseService,
    private formBuilder: FormBuilder,
    private headerService: HeaderService,
    private invoicingReportService: InvoicingReportService,
    private rentalPeriodService: RentalPeriodService,
    private title: Title,
    private toastHandlerService: ToastHandlerService) {
    this.validateForm();
  }

  async ngOnInit() {
    this.headerService.setTitle(this.nameWindow);
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    await this.getAllLists();
    this.getFirstBranchByUserAuthenticatedAsync();
  }

  ngAfterViewInit() {
    this.filterObserver = new ResizeObserver(() => {
      this.filtersHeight = this.filtersContainer?.nativeElement?.offsetHeight || 0;
    });
    this.filterObserver.observe(this.filtersContainer.nativeElement);
  }

  ngOnDestroy() {
    this.filterObserver?.disconnect();
  }

  changeBranch(branchId: number | null) {
    this.filterEnterpriseByBranchId(branchId);
    if (branchId != 0 && branchId != null) {
      this.getFirstEnterpriseByBranch(branchId);
    } else {
      this.formInvoicingReportFilter.controls["enterpriseId"].patchValue(0);
      this.formInvoicingReportFilter.controls["branchId"].patchValue(0);
    }
    this.changeFilter();
  }

  changeConceptInvoicing(conceptInvoicingId: number | null) {
    if (conceptInvoicingId === 0 || conceptInvoicingId === null || conceptInvoicingId === undefined) {
      this.formInvoicingReportFilter.controls["conceptInvoicingId"].patchValue(0);
    }
    this.changeFilter();
  }

  changeCostCenter(costCenterId: number | null) {
    if (costCenterId === 0 || costCenterId === null || costCenterId === undefined) {
      this.formInvoicingReportFilter.controls["costCenterId"].patchValue(0);
    }
    this.changeFilter();
  }

  changeEnterprise(enterpriseId: number | null) {
    if (enterpriseId != 0 && enterpriseId != null) {
      const branchId = this.listEnterprise.find(x => x.value === enterpriseId)!.branchId;
      this.formInvoicingReportFilter.controls["branchId"].patchValue(branchId);
    } else {
      this.formInvoicingReportFilter.controls["enterpriseId"].patchValue(0);
    }
    this.changeFilter();
  }

  changeFilter() {
    this.changeFilters = false;
  }

  clear() {
    this.changeFilter();
    this.validateForm();
    this.getFirstBranchByUserAuthenticatedAsync();
  }

  async exportExcel() {
    if (this.changeFilters) {
      const dateInitial = this.formInvoicingReportFilter.get("initialDate")?.value;
      const initialDate = `${dateInitial.getFullYear()}-${(dateInitial.getMonth() + 1).toString().padStart(2, '0')}`;
      const period = initialDate.slice(5);
      const year = initialDate.slice(0, -3);
      const dateFinal = this.formInvoicingReportFilter.get("finalDate")?.value;
      const finalDate = `${dateFinal.getFullYear()}-${(dateFinal.getMonth() + 1).toString().padStart(2, '0')}`;
      const periodFinal = finalDate.slice(5);
      const yearFinal = finalDate.slice(0, -3);

      const modelInvoicingReportFilter = this.formInvoicingReportFilter.value as InvoicingReportFilterModel;
      modelInvoicingReportFilter.year = parseInt(year);
      modelInvoicingReportFilter.period = parseInt(period);
      modelInvoicingReportFilter.yearFinal = parseInt(yearFinal);
      modelInvoicingReportFilter.periodFinal = parseInt(periodFinal);
      try {
        const response = await firstValueFrom(this.invoicingReportService.exportInvoicingReportIncomeReport(modelInvoicingReportFilter));
        const blob = response;
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'Informe de Ingresos (Corte).xlsx';
        a.click();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('Error al exportar el informe.', error);
      }
    } else {
      this.toastHandlerService.showToast(
        'info',
        'No se encontraron datos para exportar.'
      );
    }
  }

  filterEnterpriseByBranchId(branchId: number | null) {
    if (branchId != null) {
      this.filteredEnterprise = this.listEnterprise.filter(x => x.branchId === branchId);
      this.formInvoicingReportFilter.controls["enterpriseId"].patchValue(0);
    } else {
      this.filteredEnterprise = this.listEnterprise;
    }
  }

  async getAllLists() {
    try {
      const [branches, enterprises, costCenters, conceptsInvoicing] = await Promise.all([
        firstValueFrom(this.branchService.getAllBranchesForSelectAsync()),
        firstValueFrom(this.enterpriseService.getAllEnterprisesForSelectAsync()),
        firstValueFrom(this.costCenterService.getAllCostCentersForSelectByClientAsync(0, 0)),
        firstValueFrom(this.conceptInvoicingService.getAllConceptsInvoicingForSelectAsync()),
      ]);
      this.listBranch = branches;
      this.listEnterprise = enterprises;
      this.filteredEnterprise = this.listEnterprise;
      this.listCostCenter = costCenters;
      this.listConceptInvoicing = conceptsInvoicing;
      return true;
    } catch (error) {
      console.error('Error al obtener las listas:', error);
      return false;
    }
  }

  async getFirstBranchByUserAuthenticatedAsync() {
    try {
      const branch = await firstValueFrom(this.branchService.getFirstBranchByUserAuthenticatedAsync());
      this.formInvoicingReportFilter.controls["branchId"].patchValue(branch.branchId);
      this.getLastRentalPeriod(branch.branchId);
      this.filterEnterpriseByBranchId(branch.branchId);
      this.getFirstEnterpriseByBranch(branch.branchId);
    } catch (error) {
      console.error("Error al consultar la sucursal:", error);
    }
  }

  async getFirstEnterpriseByBranch(branchId: number) {
    try {
      const response = await firstValueFrom(this.enterpriseService.getFirstEnterpriseByBranch(branchId));
      if (!response) {
        this.toastHandlerService.showToast('error', 'La Sucursal no tiene empresas creadas.');
      } else {
        this.formInvoicingReportFilter.controls["enterpriseId"].patchValue(response.enterpriseId);
      }
    } catch (error) {
      console.error('Error al obtener la primera empresa por sucursal.', error);
    }
  }

  async getLastRentalPeriod(branchId: number) {
    try {
      const rentalPeriod = await firstValueFrom(this.rentalPeriodService.getLastRentalPeriod(branchId));
      this.formInvoicingReportFilter.controls["initialDate"].patchValue(moment(rentalPeriod.initialDate).startOf('month').toDate());
      this.formInvoicingReportFilter.controls["finalDate"].patchValue(moment(rentalPeriod.initialDate).startOf('month').toDate());
    } catch (error) {
      console.error("Error al consultar el periodo de alquiler:", error);
    }
  }

  printReport() {
    if (this.changeFilters) {
      window.print();
    } else {
      this.toastHandlerService.showToast(
        'info',
        'No se encontraron datos para imprimir.'
      );
    }
  }

  async send() {
    Object.keys(this.formInvoicingReportFilter.controls).forEach(key => {
      const control = this.formInvoicingReportFilter.get(key);
      if (control && control.invalid) {
        console.warn(`${key} es inválido`, control.errors, 'value:', control.value);
      }
    });
    if (this.formInvoicingReportFilter.valid) {
      const dateInitial = this.formInvoicingReportFilter.get("initialDate")?.value;
      const initialDate = `${dateInitial.getFullYear()}-${(dateInitial.getMonth() + 1).toString().padStart(2, '0')}`;
      const period = initialDate.slice(5);
      const year = initialDate.slice(0, -3);
      const dateFinal = this.formInvoicingReportFilter.get("finalDate")?.value;
      const finalDate = `${dateFinal.getFullYear()}-${(dateFinal.getMonth() + 1).toString().padStart(2, '0')}`;
      const periodFinal = finalDate.slice(5);
      const yearFinal = finalDate.slice(0, -3);

      if (finalDate < initialDate) {
        this.toastHandlerService.showToast('warning', 'El período final no puede ser menor al período inicial.');
        return;
      }

      const modelInvoicingReportFilter = this.formInvoicingReportFilter.value as InvoicingReportFilterModel;
      modelInvoicingReportFilter.year = parseInt(year);
      modelInvoicingReportFilter.period = parseInt(period);
      modelInvoicingReportFilter.yearFinal = parseInt(yearFinal);
      modelInvoicingReportFilter.periodFinal = parseInt(periodFinal);

      try {
        this.dataReport = await firstValueFrom(this.invoicingReportService.getIncomeReport(modelInvoicingReportFilter));
        if (this.dataReport.data && this.dataReport.data.length != 0 && this.dataReport.data.length != null) {
          this.changeFilters = true;
        } else {
          this.changeFilters = false;
          this.toastHandlerService.showToast('info', 'No se encontraron datos.');
        }
      } catch (error) {
        console.error("Error al consultar el informe:", error);
      }
    } else {
      this.showValidationMessages();
    }
  }

  showValidationMessages() {
    const controlMessages: Record<string, Record<string, string>> = {
      initialDate: {
        required: 'El campo Desde es obligatorio.'
      },
      finalDate: {
        required: 'El campo Hasta es obligatorio.'
      },
      costCenterId: {
        notNumber: 'Debe seleccionar un C.Costos válido.'
      },
      conceptInvoicingId: {
        notNumber: 'Debe seleccionar un Concepto válido.'
      }
    };

    Object.keys(controlMessages).forEach((control) => {
      const formControl = this.formInvoicingReportFilter.get(control);
      if (formControl && formControl.invalid && formControl.errors) {
        const messages = controlMessages[control];
        Object.keys(formControl.errors).forEach((errorKey) => {
          const message = messages[errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message);
          }
        });
      }
    });
  }

  validateForm() {
    this.formInvoicingReportFilter = this.formBuilder.group({
      initialDate: ['', [Validators.required]],
      finalDate: ['', [Validators.required]],
      branchId: [0],
      enterpriseId: [0],
      costCenterId: [0, [CustomValidators.numberOnlyValidator()]],
      costCenterTypeId: [0],
      conceptInvoicingId: [0, [CustomValidators.numberOnlyValidator()]]
    });
  }

}
